import { useState } from 'react'

export default function HashDisplay({ hash, chars = 16 }) {
  const [copied, setCopied] = useState(false)
  if (!hash) return null
  const truncated = hash.length > chars ? hash.substring(0, chars) + '...' : hash

  const copy = () => {
    navigator.clipboard.writeText(hash)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  return (
    <span
      onClick={copy}
      style={{
        fontSize: 10, fontFamily: 'var(--font-mono)', color: 'var(--olv-text-tertiary)',
        cursor: 'pointer', transition: 'color var(--dur-micro)',
      }}
      title="Click to copy full hash"
    >
      {copied ? 'Copied' : truncated}
    </span>
  )
}
